// src/plugins/index.ts
import { App } from 'vue'

import { CancelAppointmentUseCase } from '@/core/appointment/application/CancelAppointmentUseCase.ts'
import { CreateAppointmentUseCase } from '@/core/appointment/application/CreateAppointmentUseCase.ts'
import { EditAppointmentUseCase } from '@/core/appointment/application/EditAppointmentUseCase.ts'
import { GetAppointmentUseCase } from '@/core/appointment/application/GetAppointmentUseCase.ts'
import { AppointmentRepositoryBackendClient } from '@/core/appointment/infra/AppointmentRepositoryBackendClient.ts'
import { GetAvailabilityUseCase } from '@/core/availability/application/GetAvailabilityUseCase.ts'
import { AvailabilityRepositoryBackendClient } from '@/core/availability/infra/AvailabilityRepositoryBackendClient.ts'
import { GetBrandsUseCase } from '@/core/brand/application/GetBrandsUseCase.ts'
import { BrandRepositoryBackendClient } from '@/core/brand/infra/BrandRepositoryBackendClient.ts'
import { GetCookiesUrlUseCase } from '@/core/cookies/application/GetCookiesUrlUseCase.ts'
import { CookiesRepositoryBackendClient } from '@/core/cookies/infra/CookiesRepositoryBackendClient.ts'
import { GetPPSOPackagesUseCase } from '@/core/ppso-package/application/GetPPSOPackageUseCase.ts'
import { PPSOPackageRepositoryBackendClient } from '@/core/ppso-package/infra/PPSOPackageRepositoryBackendClient.ts'
import { GetServicesUseCase } from '@/core/service/application/GetServicesUseCase.ts'
import { ServiceRepositoryBackendClient } from '@/core/service/infra/ServiceRepositoryBackendClient.ts'
import { DEPENDENCIES_TOKEN, DependenciesProvider } from '@/core/shared/domain/dependencies.ts'
import { GetVehicleByPlateUseCase } from '@/core/vehicle/application/GetVehicleByPlateUseCase.ts'
import { VehicleRepositoryBackendClient } from '@/core/vehicle/infra/VehicleRepositoryBackendClient.ts'
import { GetWorkshopsUseCase } from '@/core/workshop/application/GetWorkshopsUseCase.ts'
import { WorkshopRepositoryBackendClient } from '@/core/workshop/infra/WorkshopRepositoryBackendClient.ts'

type Options = {
  backendUrl: string
}

export default {
  install(app: App, options: Options) {
    const { backendUrl } = options
    const workshopBackendRepository = new WorkshopRepositoryBackendClient(backendUrl)
    const brandBackendRepository = new BrandRepositoryBackendClient(backendUrl)
    const vehicleBackendRepository = new VehicleRepositoryBackendClient(backendUrl)
    const serviceBackendRepository = new ServiceRepositoryBackendClient(backendUrl)
    const availabilityBackendRepository = new AvailabilityRepositoryBackendClient(backendUrl)
    const appointmentBackendRepository = new AppointmentRepositoryBackendClient(backendUrl)
    const cookiesBackendRepository = new CookiesRepositoryBackendClient(backendUrl)
    const ppsoPackageRepository = new PPSOPackageRepositoryBackendClient(backendUrl)

    app.provide<DependenciesProvider>(DEPENDENCIES_TOKEN, {
      cancelAppointmentUseCase: new CancelAppointmentUseCase({
        appointmentRepository: appointmentBackendRepository
      }),
      createAppointmentUseCase: new CreateAppointmentUseCase({
        appointmentRepository: appointmentBackendRepository
      }),
      editAppointmentUseCase: new EditAppointmentUseCase({
        appointmentRepository: appointmentBackendRepository
      }),
      getAppointmentUseCase: new GetAppointmentUseCase({
        appointmentRepository: appointmentBackendRepository
      }),
      getBrandsUseCase: new GetBrandsUseCase({ brandRepository: brandBackendRepository }),
      getCookiesUrlUseCase: new GetCookiesUrlUseCase({
        cookiesRepository: cookiesBackendRepository
      }),
      getPPSOPackagesUseCase: new GetPPSOPackagesUseCase({
        ppsoPackageRepository: ppsoPackageRepository
      }),
      getServicesUseCase: new GetServicesUseCase({
        serviceRepository: serviceBackendRepository
      }),
      getVehicleByPlateUseCase: new GetVehicleByPlateUseCase({
        vehicleRepository: vehicleBackendRepository
      }),
      getWorkshopAvailabilityUseCase: new GetAvailabilityUseCase({
        availabilityRepository: availabilityBackendRepository
      }),
      getWorkshopsUseCase: new GetWorkshopsUseCase({
        workshopRepository: workshopBackendRepository
      })
    })
  }
}
